export const autocatalogConstants = {
  FETCH_BRANDS_REQUEST: 'AUTOCATALOG_FETCH_BRANDS_REQUEST',
  FETCH_BRANDS_SUCCESS: 'AUTOCATALOG_FETCH_BRANDS_SUCCESS',
  FETCH_BRANDS_FAIL: 'AUTOCATALOG_FETCH_BRANDS_FAIL',

  FETCH_MODELS_REQUEST: 'AUTOCATALOG_FETCH_MODELS_REQUEST',
  FETCH_MODELS_SUCCESS: 'AUTOCATALOG_FETCH_MODELS_SUCCESS',
  FETCH_MODELS_FAIL: 'AUTOCATALOG_FETCH_MODELS_FAIL',

};



// WEBPACK FOOTER //
// ./src/constants/autocatalog.constants.js